import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Scale } from 'lucide-react';
const tableData = [{
  sin: '3 hs de planificación × 40 semanas de cierre',
  costo: '120 horas de tu vida por año'
}, {
  sin: 'Conciliaciones manuales con archivos sucios',
  costo: 'Viernes por la tarde perdidos'
}, {
  sin: 'Honorarios sin actualizar hace 6 meses',
  costo: 'Inflación que te come el ingreso'
}, {
  sin: 'WhatsApp disponible 24/7 para todo cliente',
  costo: 'Domingos sin familia ni descanso'
}, {
  sin: 'Clientes tóxicos sin sistema de límites',
  costo: 'Desgaste emocional acumulado'
}, {
  sin: 'Sin estrategia de captación de clientes premium',
  costo: 'El mismo ciclo el año que viene'
}, {
  sin: 'Sin prompts específicos para ARCA',
  costo: 'Horas leyendo normativa que la IA resume en 30 segundos'
}];
export function CostComparison() {
  return <section className="py-20" data-id="element-34">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-35">
        <FadeIn className="text-center mb-12" data-id="element-36">
          <Scale className="w-12 h-12 text-brand-accent mx-auto mb-4" data-id="element-37" />
          <h2 className="text-3xl font-bold" data-id="element-38">⚖️ ¿CUÁNTO CUESTA NO TENERLO?</h2>
        </FadeIn>

        <FadeIn delay={0.1} className="mb-12 overflow-x-auto" data-id="element-39">
          <table className="w-full text-left border-collapse min-w-[600px] bg-brand-card rounded-2xl overflow-hidden" data-id="element-40">
            <thead data-id="element-41">
              <tr className="border-b border-slate-700 bg-slate-800/50" data-id="element-42">
                <th className="p-5 text-slate-300 font-medium w-1/2" data-id="element-43">
                  Sin Megapack
                </th>
                <th className="p-5 text-red-400 font-bold w-1/2" data-id="element-44">Costo real</th>
              </tr>
            </thead>
            <tbody data-id="element-45">
              {tableData.map((row, i) => <tr key={i} className="border-b border-slate-800/50 hover:bg-slate-800/20 transition-colors" data-id="element-46">
                  <td className="p-5 text-slate-300" data-id="element-47">{row.sin}</td>
                  <td className="p-5 text-red-400 font-medium" data-id="element-48">{row.costo}</td>
                </tr>)}
            </tbody>
          </table>
        </FadeIn>

        <FadeIn delay={0.2} className="text-center" data-id="element-49">
          <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-50">
            El próximo martes puede ser diferente.
          </h3>
          
        </FadeIn>
      </div>
    </section>;
}